import React, {useEffect} from "react";
import {useLocation} from "react-router-dom";

const ScrollToTop: React.FC = () => {
    const location = useLocation();

    useEffect(() => {
        // Force scroll to top on route change
        window.scrollTo(0, 0);

        // Additional safeguard with a slight delay
        const timer = setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);

        return () => clearTimeout(timer);
    }, [location.pathname]);

    return null;
};
export default ScrollToTop;
